var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRef(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5006 8.75504C12.9755 9.18937 12.3031 9.45063 11.5711 9.45063C11.3178 9.45063 11.0715 9.4193 10.8361 9.36043C11.2571 10.0037 11.5024 10.7727 11.5024 11.5981V12.8105C11.5024 13.264 11.3374 13.6793 11.065 14H13.8148C14.4683 14 15 13.4664 15 12.8105V11.5981C15 10.4182 14.4051 9.37517 13.5006 8.75504Z",
    fill: "#546EDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42894 8.8038C8.74864 8.8038 9.82227 7.72634 9.82227 6.40194C9.82227 5.07746 8.74864 4 7.42894 4C6.10925 4 5.03562 5.07746 5.03562 6.40194C5.03562 7.72634 6.10925 8.8038 7.42894 8.8038Z",
    fill: "#546EDB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5711 8.8038C12.8908 8.8038 13.9645 7.72634 13.9645 6.40194C13.9645 5.07746 12.8908 4 11.5711 4C10.9327 4 10.3519 4.25216 9.9223 4.66241C10.2653 5.15612 10.4668 5.75579 10.4668 6.40194C10.4668 7.04801 10.2653 7.64768 9.9223 8.14139C10.3519 8.55164 10.9327 8.8038 11.5711 8.8038Z",
    fill: "#546EDB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35842 8.75504C8.8334 9.18937 8.161 9.45063 7.42894 9.45063C6.69688 9.45063 6.02448 9.18946 5.49937 8.75504C4.59493 9.37517 4 10.4182 4 11.5981V12.8105C4 13.4664 4.53165 14 5.18525 14H9.67255C10.3261 14 10.8578 13.4664 10.8578 12.8105V11.5981C10.8578 10.4182 10.2629 9.37517 9.35842 8.75504Z",
    fill: "#546EDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRef);
export default __webpack_public_path__ + "static/media/ref.27e692698fe8abf4ec9d501b27f0d08c.svg";
export { ForwardRef as ReactComponent };